export const NumberOfReadableElementInPaywall = 3;
